<button
  #btnNativo
  [type]="type"
  [disabled]="disabled || loading"
  [ngClass]="classes"
> 
  <!-- Spinner de loading -->
   @if (loading) {
    <i class="fa fa-spinner fa-spin"></i>
   }

  <!-- Ícone à esquerda -->
   @if (icon && iconPosition === 'left' && !loading) {
    <i [class]="icon"></i>
   }  

  <!-- Conteúdo (texto) -->
  <ng-content />

  <!-- Ícone à direita -->
    @if (icon && iconPosition === 'right' && !loading) {
      <i [class]="icon"></i>
    }

</button>